<template>
  <section class="quote-info">
    <template  v-if="isEndorsement">
      <div
        v-for="(item,index) in compareData"
        :key="index"
        class="box">
        <h3 >{{ item.title }}</h3>
        <span
          v-if="item.secondTile"
          class="title bold">{{ item.secondTile }}</span>
        <div
          class="table"
          :class="item.class">
          <template>
            <div
              v-for="(sumItem,sumIndex) in item.list"
              v-show="!sumItem.notShow"
              :key="sumIndex"
              class="tr oll">
              <span>{{ sumItem.name }}</span>
              <template  v-if="sumItem.type == 'value'">
                <span v-if="formData[sumItem.field] === oldForm[sumItem.field]">
                  {{ sumItem.value }}
                </span>
                <span
                  v-else
                  class="compare">
                  <span
                    class="text-line color-danger">
                    {{ sumItem.oldValue }}
                  </span>

                  <span
                    class="color-success"
                  >
                    {{ sumItem.value }}
                  </span >

                </span>
              </template>
              <template  v-else-if="sumItem.type == 'array'">
                <span v-if="formData[sumItem.field] === oldForm[sumItem.field]">
                  {{ sumItem.value }}
                </span>
                <span
                  v-else
                  class="compare">
                  <span
                    class="text-line color-danger">
                    {{ sumItem.oldValue }}
                  </span>

                  <span
                    class="color-success"
                  >
                    {{ sumItem.value }}
                  </span >

                </span>
              </template>
              <template  v-else>
                <span v-if="formData[sumItem.field] === oldForm[sumItem.field]">
                  {{ showCompare(sumItem, formData[sumItem.field]) }}
                </span>
                <span
                  v-else
                  class="compare">
                  <span
                    class="text-line color-danger">
                    {{ showCompare(sumItem, oldForm[sumItem.field]) }}
                  </span>

                  <span
                    class="color-success"
                  >
                    {{ showCompare(sumItem, formData[sumItem.field]) }}
                  </span >

                </span>
              </template>
            </div>
          </template>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        v-for="(item,index) in compareData"
        :key="index"
        class="box"
        :class="item.boxClass" >
        <h3 >{{ item.title }}</h3>
        <span
          v-if="item.secondTile"
          class="title bold">{{ item.secondTile }}</span>
        <div
          class="table"
          :class="item.class">
          <template >
            <div
              v-for="(sumItem,sumIndex) in item.list"
              v-show="!sumItem.notShow"
              :key="sumIndex"
              class="tr">
              <span>{{ sumItem.name }}</span>

              <span
                v-if="sumItem.type == 'value'&&!sumItem.option"
                v-copy="sumItem.value"
                :class="{'green-tip':handleCompare(sumItem.field)}">
                {{ sumItem.value }}
              </span>
              <span
                v-else-if="sumItem.type == 'value'&&sumItem.option"
                v-copy="getName(sumItem.value)"
                :class="{'green-tip':handleCompare(sumItem.field)}">
                {{ getName(sumItem.value) }}
              </span>
              <span
                v-else-if="sumItem.type == 'file'"
                v-copy="sumItem.value&&sumItem.value.client_name"
                class="blue pointer"
                :class="{'green-tip':handleCompare(sumItem.field)}"
                @click="openFile(sumItem.value.url)">
                {{ sumItem.value&&sumItem.value.client_name }}
              </span>
              <span
                v-else-if="sumItem.type == 'array'"
                :class="{'green-tip':handleCompare(sumItem.field)}"
              >
                <span
                  v-for="(sum,index) in sumItem.value"
                  :key="'sum'+index"
                  v-copy="sum.name">{{sum.name}}<br></span>
              </span>
              <span
                v-else
                v-copy="showCompare(sumItem, formData[sumItem.field],sumItem.field)"
                :class="{'green-tip':handleCompare(sumItem.field)}">
                {{ showCompare(sumItem, formData[sumItem.field],sumItem.field) }}
                <email-tooltip
                  v-if="sumItem.field === 'email'"
                  :email="formData.email"></email-tooltip>
                <span
                  v-if="formData.is_eff_dt_delay && sumItem.field === 'pcy_cmnt_date'"
                  class="asap">(ASAP)</span>
              </span>
            </div>
          </template>
        </div>
      </div>
    </template>

    <div class="box">
      <h2>Information of Designated Operator(s)</h2>
      <div
        v-for="(item,index) in info_opera_list"
        :key="index"
        class="table">
        <div class="tr th">
          <span>Driver {{index+1}}</span>
        </div>
        <div class="tr">
          <span>Title</span>
          <!--          <span  :class="{'green-tip':compareChange(index,'title')}">{{ getOptionName('titleOptions', item.title) }}</span>-->
          <span
            v-if="!compareChange(index,'opera_title')"
            v-copy="getOptionName('titleOptions', item.opera_title)"
          >
            {{ getOptionName('titleOptions', item.opera_title) }}
          </span>
          <span
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ getOptionName('titleOptions', oldTravle(index,'opera_title')) }}
            </span>

            <span
              class="color-success">
              {{ getOptionName('titleOptions', item.opera_title)}}
            </span >
          </span>

        </div>
        <div class="tr">
          <span>Last Name</span>
          <!--          <span :class="{'green-tip':compareChange(index,'lst_nm')}">{{ item.lst_nm }}</span>-->
          <span
            v-if="!compareChange(index,'opera_lst_nm')"
            v-copy="item.opera_lst_nm"
          >
            {{ item.opera_lst_nm}}
          </span>
          <span
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ oldTravle(index,'opera_lst_nm') }}
            </span>

            <span
              class="color-success">
              {{ item.opera_lst_nm}}
            </span >
          </span>
        </div>
        <div class="tr">
          <span>First Name</span>
          <!--          <span :class="{'green-tip':compareChange(index,'fst_nm')}">{{ item.fst_nm }}</span>-->
          <span
            v-if="!compareChange(index,'opera_fst_nm')"
            v-copy="item.opera_fst_nm"
          >
            {{ item.opera_fst_nm}}
          </span>
          <span
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ oldTravle(index,'opera_fst_nm') }}
            </span>

            <span
              class="color-success">
              {{ item.opera_fst_nm}}
            </span >
          </span>
        </div>
        <div class="tr">
          <span>{{item.opera_id_type==1?'HKID':'Passport'}}</span>
          <!--          <span  :class="{'green-tip':compareChange(index,'id_no')}">{{ item.id_no }}</span>-->
          <span
            v-if="!compareChange(index,'opera_id_no')"
            v-copy="item.opera_id_no"
          >
            {{ item.opera_id_no}}
          </span>
          <span
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ oldTravle(index,'opera_id_no') }}
            </span>

            <span
              class="color-success">
              {{ item.opera_id_no}}
            </span >
          </span>
        </div>
        <div
          v-if="item.id_type==2"
          class="tr">
          <span>Nationality</span>
          <span>{{getOptionName('nationalityOptions',item.opera_id_nationality_seq)}}</span>
        </div>
        <div class="tr">
          <span>Date of Birth</span>
          <!--          <span  :class="{'green-tip':compareChange(index,'dob_date')}">{{ item.dob }}</span>-->
          <span
            v-if="!compareChange(index,'opera_dob')"
            v-copy="showHKDate(item.opera_dob)"
          >
            {{ showHKDate(item.opera_dob)}}
          </span>
          <span
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ showHKDate(oldTravle(index,'opera_dob')) }}
            </span>

            <span
              class="color-success">
              {{ showHKDate(item.opera_dob)}}
            </span >
          </span>
        </div>
        <div class="tr">
          <span>Relationship</span>
          <span
            v-copy="getAllOptionName30('relation',item.opera_rel)"
            :class="{'green-tip':compareChange(index,'opera_rel')}">{{ getAllOptionName30('relation',item.opera_rel) }}</span>
        </div>
      </div>
    </div>


  </section>
</template>
<script>
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'

export default {
  name: 'DroneQuoteInfo',
  mixins: [MixinOptions],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    preFormData: {
      type: Object,
      default: () => ({})
    },
    compareList: {
      type: Array,
      default: () => ([])
    },
    title: {
      type: Boolean,
      default: true
    },
    oldForm: {
      type: Object,
      default: () => ({})
    },
    isEndorsement:{
      type: Boolean,
      default: false
    }
  },

  computed: {
    pcy_end_dt() {
      const { period_of_cvr, pcy_cmnt_dt } = this.formData
      if(pcy_cmnt_dt && period_of_cvr) {
        return dayjs(pcy_cmnt_dt).add(period_of_cvr, 'years').format('YYYY-MM-DD')
      }
      return ''
    },
    info_opera_list(){
      let data =  {
        opera_rel:'',
        opera_title:'',
        opera_id_type:1,
        opera_id_no:'',
        opera_dob:'',
        opera_dob_date:'',
        opera_lst_nm:'',
        opera_fst_nm:'',
        opera_id_type_pic_path_id: '',
        opera_id_type_pic_path: '',
        opera_id_type_pic_url: '',
        opera_id_type_pic_thumb_url:'',
        client_name: ''
      }
      let nm_traveler= []
      let obj = JSON.parse(JSON.stringify(data))
      let {no_of_opera,info_opera_list=[]}=this.formData||{}
      let travel_no = no_of_opera
      if(info_opera_list.length<=0){
        for (var i= 0;i<travel_no;i++){
          nm_traveler.push(obj)
        }
      }else{
        nm_traveler = info_opera_list
      }
      return nm_traveler
    },
    compareData() {
      let {student_info={},acc_parent_info={},class_type,quote_coverage_list,plan_type,destination,destination_id} = this.formData||{}
      student_info = student_info||{}
      acc_parent_info = acc_parent_info||{}
      let arr =[]
      let oldArr =[]
      let detailList = [
        {
          name: 'Expected Effective Date',
          field:'pcy_cmnt_dt',
          is_time:true
        },
        {
          name: 'Third Party’s bodily injury ',
          field: 'tpbi',
          type: 'value',
          value:this.formData.tpbi_language,
        },
        {
          name: 'Number of Operator(s)',
          field: 'no_of_opera',
          type: 'value',
          value:this.formData.no_of_opera,
        },

      ]
      let list = [
        {
          title: '',
          class: 'mg-b-10',
          list:detailList
        },
        {
          title: 'Policyholder Detail',
          isCompare: false,
          isBold: true,
          hasType:false,
          list: [
            {
              name: 'Title',
              field: 'isrd_title',
              fieldCode: 'titleOptions',
              option: 1
            }, {
              name: 'Last Name',
              field: 'isrd_lst_nm',

            }, {
              name: 'First Name',
              field: 'isrd_fst_nm'
            }, {
              name: 'Date of Birth',
              field: 'isrd_dob',
              is_birth:true
            }, {
              name: this.formData.id_type==1?'HKID':'Passport',
              field: 'id_no'
            },
            {
              name: 'Mobile Number',
              field: 'mobile_no',

            },
            {
              name: 'Email',
              field: 'email',
            },
            {
              name: 'Policyholder is one of the driver?',
              field:'hldr_is_opera',
              type: 'value',
              value: this.getOptionName('yesNoOptions',this.formData.hldr_is_opera) ,

            },
          ],
        },
        {
          title: 'Correspondence Address',
          isBold: false,
          list: [
            {
              name: 'Room',
              field: 'addr_room'
            }, {
              name: 'Floor',
              field: 'addr_floor'
            }, {
              name: 'Block',
              field: 'addr_block'
            }, {
              name: 'Building / Estate',
              field: 'addr_building'
            }, {
              name: 'Street',
              field: 'addr_street'
            }, {
              name: 'District',
              field: 'addr_district',
              addressCode: 'district',
              isAddress: true
            }, {
              name: 'Area',
              field: 'addr_area',
              addressCode: 'area',
              isAddress: true
            }, {
              name: 'Country / Region',
              field: 'addr_region',
              isAddress: true,
              addressCode: 'region'
            },
          ]
        },
        {
          title: 'Information of UAS',
          isCompare: false,
          isBold: true,
          hasType:false,
          list: [
            {
              name: 'Make',
              field: 'brand',
            }, {
              name: 'Model',
              field: 'model',

            }, {
              name: 'UAS serial no.',
              field: 'uas_no'
            },
            {
              name: 'Year of manufacture',
              field: 'year_of_manu'
            },
            {
              name: 'Manufacturer and model of sensor',
              field: 'manu_model_of_sen',
            }, {
              name: 'Total weights',
              type: 'value',
              value:this.getAllOptionName30('weights',this.formData.weight_id)
            }, {
              name: 'Maximum speed limit',
              field: 'max_speed',
            },
            {
              name: 'Autopilot system',
              type: 'value',
              value: this.getOptionName('yesNoOptions',this.formData.autopilot_sys) ,
            },
            {
              name: ' Please provide details',
              type: 'value',
              value: this.formData.autopilot_detail ,
              notShow:!this.formData.autopilot_sys
            },
            {
              name: 'Expected yearly flying hours',
              type: 'value',
              value: this.formData.yearly_hours ,
            },
          ],
        },
      ]
      return list
    },
    compareChange(){
      return (index,name)=>{
        let {type} = this.form||{}
        let list = this.info_opera_list||[]
        let pre = this.oldForm||{}
        let preList =pre.info_opera_list||[]
        // if(type!=50)return  false
        if(!this.isEndorsement)return  false
        if(preList.length<=0)return false
        return list[index][name]!=preList[index][name]||false
      }
    },
    oldTravle(){
      return (index,name)=>{
        let pre = this.oldForm||{}
        let preList =pre.info_opera_list||[]
        if(preList.length<=0)return {}
        return preList[index][name]
      }
    }
  },
  methods:{
    handleCompare(filed){
      let {type} = this.formData
      if(type!=50) return false
      return  this.compareList.includes(filed)?true:false
    },
    openFile(url) {
      if(url) {
        window.open(url, '_blank')
      }
    },
    showCompare(item, field,sunF) {
      var change = field
      if (item.option) {
        switch (item.option) {
          case 1:
            change = this.getOptionName(item.fieldCode, field)
            break
          case 23:
            change = this.getAllOptionName23(item.fieldCode, field)
            break
        }
      }
      if (item.isAddress) {
        change = this.getAreaName(item.addressCode, field)
      }
      if (item.is_birth) {
        change = this.showHKDate(field)
      }
      if (item.is_time) {
        change = this.showHKTimeMin(field,item.is_end)
      }
      return change
    },
  }
}
</script>
<style lang="scss" scoped>
.quote-info {
  .box {
    margin-bottom: 15px;
  }
  .mg-b-0 {
    margin-bottom: 0!important;
  }

  .title {
    display: block;
    padding: 15px 0;
    font-size: 16px;
    font-weight: 400;
    color: #616266;
  }

  .table {
    .tr {
      .compare {
        display: flex;
        align-items: center;

        & > span {
          flex: 1;
        }
      }
    }
  }
  .asap{
    font-weight: bold;
    color: black;
    margin-left: 5px;
  }
}
</style>
